import React, { Suspense } from 'react';
import { StyledLayout } from './Layout.styles';
import Loaders from '../Loaders';
import AdminSideBar from '../AdminSideBar';

const AdminLayout = ({ children, showTemplate }) => {
  return (
    <div className="wrapper">
      <StyledLayout $showlayout={showTemplate}>
        <span className="overlay" />

        {showTemplate ? (
          <>
            <AdminSideBar />
            <div className="children">
              <Suspense fallback={<Loaders viewLoader />}>{children}</Suspense>
            </div>
          </>
        ) : (
          <div className="children">{children}</div>
        )}
      </StyledLayout>
    </div>
  );
};

export default AdminLayout;
